const csvTemplate = `brand_id,month,year,value,value_type
5d3ac305a6992471b7c976b9,1,2024,6262231137,amount
5f92628d91fef2cec7caa35d,1,2024,2964211599,amount
5d3ac305a6992471b7c976b9,2,2024,6374622615,amount
5f92628d91fef2cec7caa35d,2,2024,3088932265,amount
5d3ac305a6992471b7c976b9,3,2024,7343767804,amount
5f92628d91fef2cec7caa35d,3,2024,3329611066,amount
5d3ac305a6992471b7c976b9,4,2024,6711889059,amount
5f92628d91fef2cec7caa35d,4,2024,2484928024,amount
5d3ac305a6992471b7c976b9,5,2024,6560797934,amount
5f92628d91fef2cec7caa35d,5,2024,1835571240,amount
5d3ac305a6992471b7c976b9,6,2024,5813892591,amount
5f92628d91fef2cec7caa35d,6,2024,2816363475,amount
5d3ac305a6992471b7c976b9,7,2024,8856618622,amount
5f92628d91fef2cec7caa35d,7,2024,1575049458,amount
5d3ac305a6992471b7c976b9,8,2024,7555857926,amount
5f92628d91fef2cec7caa35d,8,2024,3364423682,amount
5d3ac305a6992471b7c976b9,9,2024,10747688370,amount
5f92628d91fef2cec7caa35d,9,2024,1540793007,amount
5d3ac305a6992471b7c976b9,10,2024,9738539072,amount
5f92628d91fef2cec7caa35d,10,2024,2431945071,amount
5d3ac305a6992471b7c976b9,11,2024,8650622850,amount
5f92628d91fef2cec7caa35d,11,2024,2768780817,amount`;

export default csvTemplate;
